"use strict";

var _defineProperty2 = require("/srv/@nexys-muilist/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/srv/@nexys-muilist/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryStringParams = exports.resolve = exports.replaceParams = exports.deserialize = exports.paramsToString = exports.getGoogleMapsAddressLink = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * get google maps address link
 * @param object with  street, zip, city, country
 * @return link
 */


var getGoogleMapsAddressLink = function getGoogleMapsAddressLink(_ref) {
  var street = _ref.street,
      zip = _ref.zip,
      city = _ref.city,
      country = _ref.country;
  var urlAddress = encodeURIComponent(street + ' ' + zip + ' ' + city + ' ' + country.name);
  var url = 'https://www.google.com/maps/?q=' + urlAddress;
  return url;
};
/**
 * takes an object and turns it into a query string
 * @param  e.g. {p1: a1, p2: a2, ...}
 * @return p1=a1&p2=a2&...
 */


exports.getGoogleMapsAddressLink = getGoogleMapsAddressLink;

var paramsToString = function paramsToString(params) {
  return Object.keys(params).map(function (key) {
    return key + '=' + encodeURIComponent(params[key]);
  }).join('&');
};
/**
 * @param k1=v1,k2=v2, ...
 * @return { k1: v1, k2: v2 .. }
 */


exports.paramsToString = paramsToString;

var deserialize = function deserialize(str) {
  return str.split(',').reduce(function (r, item) {
    var arr = item.split('=');

    if (arr.length === 2) {
      var _arr = _slicedToArray(arr, 2),
          key = _arr[0],
          value = _arr[1];

      return _objectSpread({}, r, _defineProperty2({}, key, value));
    } else return r;
  }, {});
};
/**
 * when a given url: `/foo/:myparam1/bar` replace `:myparam1` with content of `obj[myparam1]`
 * @param  url: original url
 * @param  obj: object containing the value of the params
 * @return url with substituted values
 */


exports.deserialize = deserialize;

var replaceParams = function replaceParams(uri, params) {
  var curly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!params || !(typeof params === 'object')) {
    return uri;
  }

  Object.entries(params).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    if (curly) {
      var regex = new RegExp("\\$\\{".concat(key, "\\}"), 'g');
      uri = uri.replace(regex, value);
    } else uri = uri.replace(":".concat(key), value);
  });
  return uri;
};
/**
 * "resolves" url
 * this is to aoid using the extra package `url`: https://www.npmjs.com/package/url: https://github.com/defunctzombie/node-url/blob/13a35bd35a2cdf3fbfa7ee9c6ed5b927a48d6821/url.js#L438
 * https://nodejs.org/api/url.html#url_url_resolve_from_to
 * @param  host
 * @param  path
 * @return full url
 */


exports.replaceParams = replaceParams;

var resolve = function resolve(hostIn, pathIn) {
  // match host until trailing slash
  var re = /^(.*)\/[^\/]*$/;
  var hostMatch = hostIn.match(re);
  var host = hostMatch && hostMatch[1];

  if ((host === 'http:/' || host === 'https:/') && !hostIn.endsWith('/')) {
    host = hostIn;
  } // extract path


  var reSlash = /^\/{0,1}(.*)$/;
  var pathMatch = pathIn.match(reSlash);
  var path = pathMatch && pathMatch[1];

  if (host && path) {
    return "".concat(host, "/").concat(path);
  } else return null;
};
/**
 * explode query string and extract params
 * https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 * @param  query string, can be obtained using: window.location.search
 * @return params object
 */


exports.resolve = resolve;

var getQueryStringParams = function getQueryStringParams(query) {
  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {});
};

exports.getQueryStringParams = getQueryStringParams;